// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import SpinnerOverlay from '@tcp/core/src/components/common/atoms/SpinnerOverlay';

const Loader = (props) => {
  const {
    loaderState,
    spc,
    applePayInProgress,
    isPLCCModalOpen,
    afterPayPaymentProgress,
    isPaypalPaymentProgress,
  } = props;
  if (loaderState || afterPayPaymentProgress) {
    return (
      <SpinnerOverlay
        spc={spc}
        applePayInProgress={applePayInProgress}
        isPLCCModalOpen={isPLCCModalOpen}
        afterPayPaymentProgress={afterPayPaymentProgress}
        isPaypalPaymentProgress={isPaypalPaymentProgress}
      />
    );
  }
  return null;
};

Loader.propTypes = {
  loaderState: PropTypes.bool,
  spc: PropTypes.bool,
  applePayInProgress: PropTypes.bool,
  isPLCCModalOpen: PropTypes.bool,
  afterPayPaymentProgress: PropTypes.bool,
};

Loader.defaultProps = {
  loaderState: false,
  spc: false,
  applePayInProgress: false,
  isPLCCModalOpen: false,
  afterPayPaymentProgress: false,
};

export default Loader;
